export const PRODUCT_DEFAULT_PRODUCT_PRICE_FORMAT = '<p><span data-entity="placeholder">{{productPrice}}</span></p>';
export const PRODUCT_DEFAULT_OLD_PRODUCT_PRICE_FORMAT = '<p><span data-entity="placeholder">{{oldProductPrice}}</span></p>';
export const PRODUCT_DEFAULT_FUTURE_PRODUCT_PRICE_FORMAT = '<p><span data-entity="placeholder">{{futureProductPrice}}</span></p>';
export const PRODUCT_DEFAULT_ORIGINAL_PRODUCT_PRICE_FORMAT = '<p><span data-entity="placeholder">{{originalProductPrice}}</span></p>';
export const PRODUCT_DEFAULT_PRODUCT_PREWARMING_DESCRIPTION_FORMAT = '<p><span data-entity="placeholder">{{productPrewarmingDescription}}</span></p>';
export const PRODUCT_DEFAULT_PRODUCT_PREWARMING_DISCOUNT_RATE_FORMAT = '<p><span data-entity="placeholder">{{productPrewarmingDiscountRate}}</span></p>';
export const PRODUCT_DEFAULT_PRICE_DISCOUNT_FORMAT = '<p><span data-entity="placeholder">{{productPriceDiscount}}</span></p>';

export type PrewarmingPriceDiscountOption = 'original-price' | 'old-price' | 'min-price';
export type PriceDiscountOption = 'old-price' | 'original-price';

export interface ProductPrices {
  productPricesTextFormat?: string;
  productPriceDescription?: string;
  oldProductPricesTextFormat?: string;
  priceDiscountTextFormat?: string;
  originalProductPriceTextFormat?: string;
  futureProductPricesTextFormat?: string;
  productPrewarmingDescriptionTextFormat?: string;
  productPrewarmingDiscountRateTextFormat?: string;
  /**
   * If `displayOldProductPrices` is activated, this variable will be used to handle the styles for products with
   * discounted prices.
   * If it's activated but the product doesn't have a discounted price, the styles defined in `productPricesTextFormat`
   * will be used.
   */
  productPriceOnSaleTextFormat?: string;

  prewarmingDiscountOption: PrewarmingPriceDiscountOption;
  priceDiscountOption: PriceDiscountOption;

  displayProductPrices: boolean;
  displayProductPriceDescription: boolean;
  displayOldProductPrices: boolean;
  displayFutureProductPrices: boolean;
  displayProductPrewarmingDescription: boolean;
  displayProductPrewarmingDiscountRate: boolean;
  hidePrewarmingWhenDiscountApplied: boolean;
  displayPriceDiscount: boolean;
  displayOriginalProductPrice: boolean;
}
